// Accordion toggle
/*
window.toggle = function (btn) {
    const item = btn.closest('.faq-item');
    const isOpen = item.classList.contains('open');
    // close all
    document.querySelectorAll('.faq-item.open').forEach(el => el.classList.remove('open'));
    if (!isOpen) item.classList.add('open');
}
    */


function getVisibleHeight(el) {
    let rect = el.getBoundingClientRect();
    let windowHeight = (window.innerHeight || document.documentElement.clientHeight);

    let visibleTop = Math.max(rect.top, 0);
    let visibleBottom = Math.min(rect.bottom, windowHeight);

    let visibleHeight = visibleBottom - visibleTop;

    return Math.max(0, visibleHeight); 
}

function checkHeaderOffset() {
    let header = $('.eq-header');
    let announcementBar = $('.eq-announcement-bar');
    let totalOffset = 0;
    let announcementBarOffset = 0;

    if (header.length && header.is(':visible')) {
        totalOffset += header.outerHeight();
    }

    if (announcementBar.length && announcementBar.is(':visible')) {
        announcementBarOffset = getVisibleHeight(announcementBar[0]);
    }

    if (announcementBar.length && announcementBar.is(':visible') ) {
        totalOffset += getVisibleHeight(announcementBar[0]);
    }

    document.documentElement.style.setProperty('--header-offset', `${totalOffset}px`);
    document.documentElement.style.setProperty('--announcement-bar-offset', `${announcementBarOffset}px`);
}

// Scroll reveal
const scrollObserver = new IntersectionObserver(entries => {
    entries.forEach(e => {
        if (e.isIntersecting) {
            e.target.classList.add('visible');
            scrollObserver.unobserve(e.target);
        }
    });
}, { threshold: 0.08 });

document.querySelectorAll('.faq-section').forEach(el => scrollObserver.observe(el));

// Active nav pill
const sections = document.querySelectorAll('.faq-section[id]');
const pills = document.querySelectorAll('.nav-pill');
const navObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
        if (e.isIntersecting) {
            pills.forEach(p => p.style.color = '');
            const active = document.querySelector(`.nav-pill[href="#${e.target.id}"]`);
            // if (active) active.style.color = 'var(--sage)';
        }
    });
}, { threshold: 0.2 });

sections.forEach(s => navObs.observe(s));

/*
document.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', function () {
        const item = this.closest('.faq-item');
        const isOpen = item.classList.contains('open');

        document.querySelectorAll('.faq-item.open').forEach(el => {
            el.classList.remove('open');
        });

        if (!isOpen) {
            item.classList.add('open');
        }
    });
});
*/

// FAQ Accordion
document.querySelectorAll('.faq-section').forEach((section) => {

    const buttons = section.querySelectorAll('.faq-q');

    buttons.forEach((button) => {

        button.addEventListener('click', function () {

            const item = this.closest('.faq-item');
            const isOpen = item.classList.contains('open');

            // Close only current section accordions
            section.querySelectorAll('.faq-item.open').forEach((el) => {
                el.classList.remove('open');
            });

            // Open current item
            if (!isOpen) {
                item.classList.add('open');
            }
        });
    });
});

window.addEventListener('load', function() {
    checkHeaderOffset();
});

window.addEventListener('resize', function() {
    checkHeaderOffset();
});